import { NotificationType } from '../../enums/notification/notification-type.enum';
import { SocialNetworkContentType } from '../../enums/social-network/social-network-content-type.enum';
import { SocialNetworkThreadOwnerType } from '../../enums/social-network/social-network-thread-owner-type.enum';

export class NotificationMetadata {
  authorName?: string;
  hubId?: string;
  hubSlug?: string;
  groupId?: string;
  caseId?: string;
  commentId?: string;
  eventId?: string;
  eventSlug?: string;
  threadId?: string;
  instanceType: SocialNetworkThreadOwnerType;
  contentType: SocialNetworkContentType;
  type: NotificationType;
}
